import React, { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { Reveal } from "./motion";
import { API_URL } from "../lib/shop";

export default function InstagramGallery() {
  const [feed, setFeed] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/instagram/feed`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("unavailable"))))
      .then((d) => {
        if (!cancelled && d && d.items && d.items.length && d.username) setFeed(d);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!feed) return null;

  return (
    <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-36 border-t border-white/10" data-testid="instagram-section">
      <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
        <div>
          <p className="font-mono text-[10px] md:text-xs tracking-[0.3em] text-ash uppercase mb-4">As seen on Instagram</p>
          <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl">@{feed.username}</h2>
        </div>
        <a
          href={feed.profile_url}
          target="_blank"
          rel="noreferrer"
          className="group inline-flex items-center gap-2.5 font-mono text-[11px] tracking-[0.2em] border border-white/20 hover:border-bone hover:bg-bone hover:text-ink px-6 py-3.5 transition-all duration-300"
          data-testid="instagram-follow-link"
        >
          <Instagram className="w-4 h-4" /> FOLLOW US
        </a>
      </Reveal>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
        {feed.items.map((p) => (
          <a
            key={p.id}
            href={p.permalink}
            target="_blank"
            rel="noreferrer"
            className="relative aspect-square overflow-hidden bg-card group"
            data-testid={`instagram-post-${p.id}`}
          >
            <img
              src={p.image}
              alt={p.caption ? p.caption.slice(0, 80) : "Instagram post"}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
            />
            <span className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-ink/70 p-1.5">
              <Instagram className="w-3.5 h-3.5" />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}